import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.jpg';
import { useLocation } from 'react-router-dom';
import AuthService from '../../services/authService';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [isTeacher, setIsTeacher] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userProfile = await AuthService.fetchUserProfile();
        if (userProfile) {
          setUser(userProfile);
        } else {
          setUser(null);
        }
      } catch (error) {
        setUser(null);
      }

      const decodedToken = AuthService.decodeToken();
      if (decodedToken && decodedToken.is_teacher === 1) {
        setIsTeacher(true);
      } else {
        setIsTeacher(false);
      }
    };
    fetchUser();
  }, []);

  const handleLogout = () => {
    AuthService.clearToken();
    setUser(null);
    setIsTeacher(false);
    navigate('/dang-nhap');
  };
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <img src={logo} alt="Logo Nam Kiến Văn" className="h-10 w-auto" />
            <span className="text-base font-semibold text-blue-800 bg-gray-100 px-3 py-1 rounded-md">
              Nam Kiến Văn Education
            </span>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className={`nav-link ${isActive('/') ? 'text-blue-600 font-semibold border-b-2 border-blue-600' : ''}`}>
              Trang chủ
            </Link>
            <Link to="/tin-tuc" className={`nav-link ${isActive('/tin-tuc') ? 'text-blue-600 font-semibold border-b-2 border-blue-600' : ''}`}>
              Tin tức
            </Link>
            <Link to="/giao-vien" className={`nav-link ${isActive('/giao-vien') ? 'text-blue-600 font-semibold border-b-2 border-blue-600' : ''}`}>
              Giáo viên
            </Link>

            <Link to="/lich-hoc" className={`nav-link ${isActive('/lich-hoc') ? 'text-blue-600 font-semibold border-b-2 border-blue-600' : ''}`}>
              Lịch học
            </Link>
            <Link to="/khoa-hoc" className={`nav-link ${isActive('/khoa-hoc') ? 'text-blue-600 font-semibold border-b-2 border-blue-600' : ''}`}>
              Khoá học
            </Link>
          </div>

          {/* Action Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            {user ? (
              <>
                <span className="text-gray-700 font-medium">Xin chào, {user.username || user.full_Name || 'User'}</span>
                <Link to="/ho-so" className={`nav-link ${isActive('/ho-so') ? 'text-blue-600 font-semibold border-b-2 border-blue-600' : ''}`}>
                  Hồ sơ
                </Link>
                {isTeacher && (
                  <Link
                    to="/admin"
                    className="btn btn-secondary"
                  >
                    Admin
                  </Link>
                )}
                <button
                  onClick={handleLogout}
                  className="btn btn-primary"
                >
                  Đăng xuất
                </button>
              </>
            ) : (
              <Link to="/dang-nhap" className="btn btn-primary">
                Đăng nhập
              </Link>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-200">
              <Link
                to="/tin-tuc"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium hover:text-gray-900 hover:bg-gray-50 ${isActive('/tin-tuc') ? 'text-blue-600 font-semibold underline' : 'text-gray-700'
                  }`}
              >
                Tin tức
              </Link>
              
              <Link
                to="/giao-vien"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium hover:text-gray-900 hover:bg-gray-50 ${isActive('/giao-vien') ? 'text-blue-600 font-semibold underline' : 'text-gray-700'
                  }`}
              >
                Giáo viên
              </Link>

              
              <Link
                to="/lich-hoc"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium hover:text-gray-900 hover:bg-gray-50 ${isActive('/lich-hoc') ? 'text-blue-600 font-semibold underline' : 'text-gray-700'
                  }`}
              >
                Lịch học
              </Link>
              <Link
                to="/khoa-hoc"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium hover:text-gray-900 hover:bg-gray-50 ${isActive('/khoa-hoc') ? 'text-blue-600 font-semibold underline' : 'text-gray-700'
                  }`}
              >
                Khoá học
              </Link>
              <div className="pt-4 pb-3 border-t border-gray-200">
                {user ? (
                  <>
                    <span className="block px-3 py-2 rounded-md text-base font-medium text-gray-700">
                      Xin chào, {user.username || user.fullName || 'User'}
                    </span>
                    <Link
                      to="/ho-so"
                      className="block px-3 py-2 rounded-md text-base font-medium text-blue-600 hover:text-blue-800 hover:bg-gray-50"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Hồ sơ
                    </Link>
                    {isTeacher && (
                      <Link
                        to="/admin"
                        className="block px-3 py-2 rounded-md text-base font-medium text-blue-600 hover:text-blue-800 hover:bg-gray-50"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Admin
                      </Link>
                    )}
                    <button
                      onClick={() => {
                        handleLogout();
                        setIsMobileMenuOpen(false);
                      }}
                      className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-blue-600 hover:text-blue-800 hover:bg-gray-50"
                    >
                      Đăng xuất
                    </button>
                  </>
                ) : (
                  <Link
                    to="/dang-nhap"
                    className="block px-3 py-2 rounded-md text-base font-medium text-blue-600 hover:text-blue-800 hover:bg-gray-50"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Đăng nhập
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
